import React from 'react';
import Alert from 'react-bootstrap/Alert';
import styles from '../../styles/rca/RCASearch.module.scss';

const RCAIssueNotice = () => {

    return (
        <Alert variant="info" className={styles.smallInfo}>
            <p className={styles.topic}>IMPORTANT</p>
            <p>Polița RCA va fi emisă numai dupa transmiterea urmatoarelor documente la adresa asigurari@conso.ro:</p>
            <ul>
                <li><span className="font-weight-bold">Autoturisme noi</span> - Copie după factura fiscala emisă de dealerul auto, din care sa reiasă detaliile autoturismului (model, marca, serie sasiu, an fabricație)</li>
                <li><span className="font-weight-bold">Autoturisme rulate</span> - Copie după contractul de vânzare-cumparare. Dacă au trecut mai mult de 30 zile de la data încheierii contractului, acesta trebuie să fie avizat de Administrația Financiară.</li>
            </ul>
        </Alert>
    );
}

export default RCAIssueNotice;